import headerBgUrl from "./Flow_04.mp4";

export const mountHeaderBackground = (container: HTMLElement): (() => void) => {
    const video = document.createElement("video");
    video.src = headerBgUrl;
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    video.playbackRate = 0.5;
    video.addEventListener("loadedmetadata", () => {
        video.playbackRate = 0.5;
    });
    video.setAttribute("aria-hidden", "true");
    Object.assign(video.style, {
        position: "absolute",
        inset: "0",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        opacity: "0.20",
        filter: "grayscale(1) invert(1)",
        pointerEvents: "none",
    });
    container.appendChild(video);

    return () => {
        video.remove();
    };
};
